import React from 'react';
import { makeStyles } from '@mui/styles';
import { translate } from 'translations/translator';
import { HwtButton } from 'components/@common/Buttons/HwtButton';

type Props = {
  isFirstStep: boolean;
  isLastStep: boolean;
  currentStep: any;
  onGoBackStep: () => void;
  onGoToNextStep: () => void;
  onFinish: () => void;
  onSkip: () => void;
  getTourBtnActionGroupStyle: () => void;
};

const t = key => translate('tour', key);
const TourBtnActionGroup: React.FC<Props> = ({
  isFirstStep,
  isLastStep,
  onGoBackStep,
  onGoToNextStep,
  onFinish,
  onSkip,
  getTourBtnActionGroupStyle
}) => {
  const classes: any = useStyles();

  return (
    <div className={classes.btnContainer} style={(getTourBtnActionGroupStyle() as any) || {}}>
      <div className={classes.btnRow}>
        <HwtButton variant={'contained'} onClick={onGoBackStep} disabled={isFirstStep}>
          {t('previousStep')}
        </HwtButton>
        {isLastStep ? (
          <HwtButton variant={'contained'} onClick={onFinish}>
            {t('finishTour')}
          </HwtButton>
        ) : (
          <HwtButton variant={'contained'} onClick={onGoToNextStep} disabled={isLastStep}>
            {t('nextStep')}
          </HwtButton>
        )}
      </div>
      <div className={classes.btnRow}>
        <HwtButton
          onClick={onSkip}
          variant={'text'}
          style={{
            border: 'none',
            backgroundColor: 'transparent !important'
          }}
        >
          {t('skipTour')}
        </HwtButton>
      </div>
    </div>
  );
};

const useStyles = makeStyles((): any => {
  return {
    btnContainer: () => ({
      position: 'absolute',
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      zIndex: 9999,
      display: 'flex',
      flexDirection: ' column',
      alignItems: 'center',
      justifyContent: 'center'
    }),
    btnRow: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      '&:first-child > button': {
        margin: '0 10px'
      },
      '& + &': {
        marginTop: '20px'
      }
    }
  } as any;
});

export default TourBtnActionGroup;
